/* eslint-env browser */
import * as toGeoJSON from '@tmcw/togeojson';
const parseKMLToGeoJSON = async kmlTextOrUrl => {
  // Fetch if it's a URL, otherwise use as text
  const kmlText = kmlTextOrUrl.startsWith('http://') || kmlTextOrUrl.startsWith('https://') ? await (await fetch(kmlTextOrUrl)).text() : kmlTextOrUrl;
  const xmlDoc = new DOMParser().parseFromString(kmlText, 'text/xml');

  // Check for DOM parsing errors
  const parserError = xmlDoc.querySelector('parsererror');
  if (parserError) {
    throw new Error("KML parsing error: ".concat(parserError.textContent));
  }
  return toGeoJSON.kml(xmlDoc);
};

/**
 * @function evaluate - evaluate kmlToGeoJSONBehavior
 *
 * Accept a public url or File blob and parse the contents.
 * Produce a GeoJSON representation of the KML structure.
 */
export const evaluate = async (entity, entityName, source, content, parentContentPath, transientContext, nativeFunctions, evaluateSource) => {
  const fileURL = await evaluateSource(source.url, content, parentContentPath, transientContext, nativeFunctions);
  const file = await evaluateSource(source.file, content, parentContentPath, transientContext, nativeFunctions);
  if (fileURL) {
    return parseKMLToGeoJSON(fileURL);
  }
  if (!file) {
    throw new Error('kmlToGeoJSONBehavior: Either a URL or file must be provided');
  }
  const rawFile = file.file;
  const kmlText = await rawFile.text();
  return parseKMLToGeoJSON(kmlText);
};
export default {
  evaluate
};